enum QuestionType {
    None = '',
    Text = 'Text',
    Number = 'Number',
    Dropdown = 'Dropdown',
    DateTime = 'DateTime',
    FileUpload = 'FileUpload',
    CascadingDropdown = 'CascadingDropdown',
    MultiSelect = 'MultiSelect',
    ReferredIndividualName = 'ReferredIndividualName',
    ReferredIndividualEmail = 'ReferredIndividualEmail',
}

export default QuestionType;
